(function() {
  'use strict';

  // This component wraps the existing FAQ controller
  // No controller needed here as we're using the existing FAQController
  // The binding for faqId will be passed to the controller via bindings

  angular.module('component.faqs')
    .component('faqForm', {
      templateUrl: 'app/components/faqs/form.html',
      controller: 'FAQController',
      controllerAs: 'faqCtrl',
      bindings: {
        faqId: '<'
      }
    });
})();
